import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { UserWithSummary } from '@core/interfaces/kpis.interface'

import { FrameAvatar, FrameAvatarComponent } from '@shared/components/frame-avatar/frame-avatar.component'
import { ScoreComponent } from '@shared/components/score/score.component'

@Component({
  selector: 'pilots-item',
  standalone: true,
  imports: [RouterLink, FrameAvatarComponent, ScoreComponent],
  templateUrl: './pilots-item.component.html',
  styleUrls: ['./pilots-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PilotsItemComponent {
  user = input.required<UserWithSummary>()
  score = computed(() => this.user().summary?.percentage || 0)

  frameAvatar = computed(() => {
    const data = this.user()
    if (!data) return null

    const frameAvatar: FrameAvatar = {
      img: data.avatar
        ? data.avatar
        : 'https://secure.gravatar.com/avatar/f7219bbd71f453e41750fa3c63a11da1?size=64&default=mm',
      score: this.score(),
      isFrame: true
    }
    return frameAvatar
  })
}
